import React, { Component } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import Icon from '../../icons/Icon';
import UserService from '../../service/UserService';
import ServiceContainer from '../../config/ServiceContainer';
import { ServiceNames } from '../../constant/ServiceNames';
import LanguageUtil from '../../util/LanguageUtil';

class AccountQrCodeComponent extends Component<{}, State> {
  public state: State = new State();

  private readonly userService: UserService = ServiceContainer.getInstance().get(ServiceNames.USER);

  public render() {
    const { qrData, blur } = this.state;
    return (
      <div className={'h-full w-full bg-white rounded-[10px] border border-[#BDBDBD] border-opacity-[0.5]'}>
        <div className={'ml-[30px] mt-[10px] mb-[10px]'}>
          <span className={'text-2xl 2xl:text-3xl font-medium text-f-black-2'}>
            {LanguageUtil.get({ id: 'common.label.qrCode', defaultMessage: 'QR Code' })}
          </span>
          <Icon icon={'eye'} size={24} className={'float-right mt-[5px] mr-[20px] cursor-pointer'} onClick={() => this.setState({ blur: !blur })} />
        </div>
        <div
          className={
            blur
              ? 'flex items-center justify-center bg-[#F6F8FA] h-[calc(100%-50px)] rounded-b-lg blur-md'
              : 'flex items-center justify-center bg-[#F6F8FA] h-[calc(100%-50px)] rounded-b-lg'
          }
        >
          <QRCodeSVG size={200} value={qrData} />
        </div>
      </div>
    );
  }

  public async componentDidMount() {
    const qrData: Record<string, any> = await this.userService.getQRData();
    qrData.authTokens = { refresh_token: '' };
    this.setState({ qrData: JSON.stringify(qrData) });
  }
}

class State {
  qrData: string = '';
  blur: boolean = true;
}

export default AccountQrCodeComponent;
